"use client";

import { Typography } from "@kyan/ui";

import { Divider } from "#/components/Divider/Divider";
import { useAccount } from "#/store/wallet/account/account";

import { BugBounty } from "./components/BugBounty/BugBounty";
import { Earnings } from "./components/Earnings/Earnings";
import { RedeemReferralCode } from "./components/RedeemReferralCode/RedeemReferralCode";
import { ReferralPanel } from "./components/ReferralPanel/ReferralPanel";

export default function Rewards() {
  const { isAccountConnected } = useAccount();

  return (
    <div className="mt-4 flex max-w-222.5 flex-col gap-6">
      <div className="flex justify-between">
        <div className="grid gap-2">
          <Typography bold grotesk element="h2">
            Rewards Hub
          </Typography>
          <Typography size={16}>Manage and collect your rewards</Typography>
        </div>
        <RedeemReferralCode />
      </div>

      <Earnings />
      <ReferralPanel />

      {isAccountConnected && (
        <>
          <Divider />
          <BugBounty />
        </>
      )}
    </div>
  );
}
